import React, { useState } from 'react';
import { getAccessToken } from '../../auth';
import Button from '../../lib/button/Button';
import TextField from '../../lib/text-field/TextField';
import axios from 'axios';
import { envConfig } from '../../config';

interface IUserDataFormProps {
	user: {
		id: string;
		name: string;
		lastName: string;
	};
}

const UserDataForm: React.FC<IUserDataFormProps> = ({ user }) => {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [firstName, setFirstName] = useState(user?.name || '');
	const [lastName, setLastName] = useState(user?.lastName || '');

	const updateUser = async (firstName: string, lastName: string) => {
		setIsSubmitting(true);

		await axios.put(
			`${envConfig.API_BASE_URL}/user-service/v1/user/${user.id}`,
			{
				name: firstName,
				lastName: lastName,
			},
			{
				headers: {
					Authorization: 'Bearer ' + (await getAccessToken()),
				},
			}
		);

		setIsSubmitting(false);
	};

	return (
		<form
			style={{ display: 'flex', gap: '10px', alignItems: 'center' }}
			onSubmit={(e) => {
				e.preventDefault();
				updateUser(firstName, lastName);
			}}
		>
			<TextField
				name='first-name'
				label='First name'
				value={firstName}
				onChange={(value: any) => setFirstName(value)}
			/>
			<TextField
				name='last-name'
				label='Last name'
				value={lastName}
				onChange={(value: any) => setLastName(value)}
			/>
			<div style={{ marginBottom: '16px' }}>
				<Button
					variant='outlined'
					color='primary'
					size='small'
					type='submit'
					loading={isSubmitting}
				>
					Save
				</Button>
			</div>
		</form>
	);
};

export default UserDataForm;
